// @ts-check
import ResultSearchForm from './ResultSearchForm';

export default ResultSearchForm;
